import { GenericAttachmentUploadFunctions } from "./generic-attachment-upload-functions";

export class GenericAttachmentUploadView<T> extends GenericAttachmentUploadFunctions<T> {

    onSelectedFiles(): void {
        this.onSelectedFilesFunction(this.getSelectedFileList);
    }
    onUploadFiles(attachmentEntry: any): void {
        this.onUploadFileFunction(attachmentEntry);
    }
    onAttachmentDeleteFiles(attachmentEntry: any, Attachments2_Lines: any[]): void {
        this.onAttachmentDeleteFileFunction(attachmentEntry, Attachments2_Lines);
    }
  async  onAttachmentGetFiles(attachmentEntry: any) {
   await this.onAttachmentGetFileFunction(attachmentEntry);
      
    }

}